import './App.css';
import { useEffect, useState } from 'react';
import routes from './routes';
import Menu from './components/Menu/Menu';
import { useLocation } from 'react-router-dom'
import Loader from './components/Loader/Loader';
import { useOrders } from './pages/DefaultPage/connect/Orders';
import ServerErr from './components/Errors/500';
import SplashView from './pages/Splash/Splash';
import DesktopHeader from './components/DesktopHeader/DesktopHeader';
import { useUserInfo } from './pages/Profile/connect/User';
import MobileLayout from './Layouts/MobileLayout';
import DesktopLayout from './Layouts/DesktopLayout';

function App() {
  const [isShowNemads, setIsShowNemads] = useState(false)
  const [showSplash, setShowSplash] = useState(false);
  const { getUserInfo, getIsBusinessUser, getUserInfoWithMobile } = useUserInfo(
    (state) => state.actions
  );
  const userInfoWithMobile = useUserInfo((state) => state.userInfoWithMobile);


  const getUserInfoWithMobileHandler = async () => {
    await getUserInfoWithMobile(
      localStorage.getItem("phoneNumber")
        ? localStorage.getItem("phoneNumber")
        : localStorage.getItem("mergedValue")
    );
  };



  const [checkWidth, setCheckWidth] = useState(window.innerWidth)
  const reportWindowSize = () => {
    setCheckWidth(window.innerWidth)
  }
  window.onresize = reportWindowSize;
  const location = useLocation();
  useEffect(() => {
    // getUserInfoWithMobileHandler();
    let darkMode = localStorage.getItem("veeu-dark-mode");
    if (darkMode === "true") {
      document.getElementById("root").classList.add("dark-mode");
    } else {
      document.getElementById("root").classList.remove("dark-mode");
    }
    if (location.pathname.startsWith("/chatPage")) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto'; // یا 'visible' بسته به نیاز شما
    }
    // if (location.pathname == "/") {
    //   setShowSplash(true)
    //   setTimeout(() => {
    //     setShowSplash(false)
    //   }, 3500);
    // }

    // if (userInfoWithMobile.length == 0) {
    //   // localStorage.clear()
    //   console.log("userInfoWithMobile");
    //   console.log(userInfoWithMobile);
    // }
  }, []);


  return (
    <>
      {checkWidth > 1022 ?
        <DesktopLayout />
        :
        <MobileLayout />
      }
      {
        isShowNemads && (
          <div onClick={() => setIsShowNemads(false)} className='fixed top-0 left-0 z-50 bg-white border'>
            <div className='flex items-center justify-center w-full mt-1 cursor-pointer '>
              <p className='w-max px-2 bg-red-400 rounded-full text-white text-center'>
                x
              </p>
            </div>
            <div className='w-full flex items-center justify-center'>
              <a className='w-[100px] h-[100px] ' referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=485134&Code=3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT'>
                <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=485134&Code=3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT' alt='enamad'
                  Code='3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT' />
              </a>
            </div>
            <div className='w-full flex items-center justify-center'>
              <a className='w-[100px] h-[100px] ' referrerpolicy='origin' target='_blank' href='https://logo.samandehi.ir/Verify.aspx?id=373235&p=xlaojyoexlaouiwkxlaodshw'>
                <img referrerpolicy='origin' alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=373235&p=qftiyndtqftiodrfqftiujyn'
                  Code='3ukamdkJwYq8fkxrUeRB1gPFXGVbl7wT' />
              </a>
            </div>
          </div>
        )
      }
    </>
  );
}

export default App;
